// extracted by mini-css-extract-plugin
export default {"locationFont":"hsKRY2"};